import React, { useState, useEffect } from 'react';
import {
    MaterialUiCore,
    // @ts-ignore
} from '@gscope-mfe/common-libs';
const { Typography, TextField, IconButton } = MaterialUiCore;
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import classes from './DownloadFrameworkCss.module.css';
import DownloadFrameworkTable from './DownloadFrameworkTable';
import RefreshIcon from '@mui/icons-material/Refresh';

const FilesToDownload = ({
    downloadHistory,
    showTableHead,
    startDownloadFile,
    formatTime,
    downloadingTransactionId,
    startFileGeneration,
    setSelectedTab,
    fetchDownloadhistory,
}) => {
    const [fileName, setFileName] = useState('');

    const Filegeneration = (fileName) => {
        startFileGeneration(fileName);
        setFileName('');
    };

    return (
        <>
            <div className={classes.filesToDownloadContainer}>
                <div className={classes.alertBar}>
                    <InfoOutlinedIcon />
                    <Typography data-testid="download-alert-title" className={classes.alertText}>
                        Please provide a description below and click on ✔️ to initiate the download
                    </Typography>
                </div>
                <div className={classes.margin}>
                    <Typography
                        data-testid="download-description-title"
                        variant="subtitle2"
                        className={classes.subTitle}
                    >
                        Download description
                    </Typography>
                    <TextField
                        variant="outlined"
                        value={fileName}
                        onChange={(e) => setFileName(e.target.value)}
                        placeholder="Type here"
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <>
                                    <IconButton
                                        data-testid="start-file-generation"
                                        onClick={() => Filegeneration(fileName)}
                                    >
                                        <CheckIcon />
                                    </IconButton>
                                    <IconButton data-testid="clear-text" onClick={() => setFileName('')}>
                                        <CloseIcon />
                                    </IconButton>
                                </>
                            ),
                        }}
                        inputProps={{ 'data-testid': 'file-name-input' }}
                    ></TextField>
                </div>
            </div>
            <div className={classes.recentDownloadSection}>
                <Typography variant="subtitle2" className={classes.subTitle}>
                    Recent downloads ({downloadHistory?.length > 4 ? <>4</> : <>{downloadHistory?.length}</>})
                    <RefreshIcon
                        data-testid="refresh-icon"
                        className={classes.pointer}
                        onClick={fetchDownloadhistory}
                    />
                </Typography>
                <Typography
                    variant="subtitle2"
                    onClick={() => setSelectedTab('download_history')}
                    className={classes.subTitle}
                    style={{ color: '#0071DC', cursor: 'pointer' }}
                    data-testid="view-all-files"
                >
                    View all files
                </Typography>
            </div>
            <DownloadFrameworkTable
                showTableHead={showTableHead}
                filteredDownloadHistory={downloadHistory?.length > 4 ? downloadHistory?.slice(0, 4) : downloadHistory}
                startDownloadFile={startDownloadFile}
                formatTime={formatTime}
                downloadingTransactionId={downloadingTransactionId}
            />
        </>
    );
};

export default FilesToDownload;
